import {
  Thermometer,
  Zap,
  Battery,
  TrendingDown,
  Clock,
  Settings,
} from "lucide-react";

export const productsData = {
  consumer: {
    "lithium-ion-battery": {
      id: "lithium-ion-battery",
      title: "Lithium ion Battery",
      category: "Consumer Battery",
      description:
        "High-performance lithium-ion batteries with rapid charging and superior power density.",
      images: [
        "/lithiumionbattery.png",
        // "/Products/graphene-li-ion-2.jpg",
      ],
      features: [
        { icon: Zap, title: "Fast Charging", desc: "80% in 15 minutes" },
        {
          icon: Battery,
          title: "High Power",
          desc: "Exceptional power density",
        },
        {
          icon: Thermometer,
          title: "Thermal Stable",
          desc: "Wide temperature range",
        },
        { icon: Clock, title: "Long Cycle Life", desc: "1500+ cycles" },
        {
          icon: Settings,
          title: "Flexible Design",
          desc: "Custom configurations",
        },
        {
          icon: TrendingDown,
          title: "Eco-Friendly",
          desc: "Sustainable materials",
        },
      ],
      applications: [
        { 
          name: "Portable Electronics",
          image: "/Products/applications/portable.webp"
        },
        { 
          name: "Power Tools",
          image: "/Products/applications/powertool.png"
        },
        { 
          name: "Medical Devices",
          image: "/Products/applications/medical.png"
        },
        { 
          name: "Emergency Systems",
          image: "/Products/applications/emergency.png"
        },
      ],
      specs: {
        capacity: "2000-10000mAh",
        voltage: "3.7V",
        temperature: "-20°C to +60°C",
        cycleLife: "1500+ cycles",
      },
    },
    "prismatic-cell": {
      id: "prismatic-cell",
      title: "Prismatic Cell",
      category: "Consumer Battery",
      description:
        "Compact prismatic cells optimized for space-constrained applications with excellent performance.",
      images: [
        "/prismacell.png",
        // "/Products/prismatic-cell-2.jpg",
      ],
      features: [
        {
          icon: Battery,
          title: "Space Efficient",
          desc: "Compact form factor",
        },
        { icon: Zap, title: "High Capacity", desc: "Optimal energy storage" },
        {
          icon: Thermometer,
          title: "Thermal Management",
          desc: "Excellent heat dissipation",
        },
        {
          icon: Clock,
          title: "Long Service Life",
          desc: "Reliable performance",
        },
        {
          icon: Settings,
          title: "Easy Integration",
          desc: "Simple installation",
        },
        {
          icon: TrendingDown,
          title: "Stable Output",
          desc: "Consistent performance",
        },
      ],
      applications: [
        { 
          name: "Laptops",
          image: "/Products/applications/laptop.png"
        },
        { 
          name: "Portable Backup Packs",
          image: "/Products/applications/powerbank.png"
        },
        { 
          name: "UPS Systems",
          image: "/Products/applications/ups.webp"
        },
        { 
          name: "Emergency Lighting",
          image: "/Products/applications/lighting.png"
        },
      ],
      specs: {
        capacity: "1500-8000mAh",
        voltage: "3.7V",
        temperature: "-20°C to +60°C",
        cycleLife: "800+ cycles",
      },
    },
    bms: {
      id: "bms",
      title: "Battery Management System",
      category: "Consumer Battery",
      description:
        "Intelligent BMS ensuring optimal performance, safety, and longevity of battery systems.",
      images: ["/bms.png", 
        // "/Products/bms-2.jpg"
      ],
      features: [
        {
          icon: Settings,
          title: "Smart Monitoring",
          desc: "Real-time tracking",
        },
        { icon: Zap, title: "Safety Protection", desc: "Multiple protections" },
        { icon: Battery, title: "Cell Balancing", desc: "Optimal performance" },
        {
          icon: Thermometer,
          title: "Thermal Control",
          desc: "Temperature management",
        },
        { icon: Clock, title: "State of Charge", desc: "Accurate monitoring" },
        {
          icon: TrendingDown,
          title: "Communication",
          desc: "Multiple interfaces",
        },
      ],
      applications: [
        { 
          name: "Electric Vehicles",
          image: "/Products/applications/ev.png"
        },
        { 
          name: "Energy Storage",
          image: "/Products/applications/energystore.png"
        },
        { 
          name: "Industrial",
          image: "/Products/applications/industry.png"
        },
        { 
          name: "Marine",
          image: "/Products/applications/marine.png"
        },
      ],
      specs: {
        capacity: "Up to 1000V",
        voltage: "12-1000V",
        temperature: "-40°C to +85°C",
        cycleLife: "10+ years",
      },
    },
  },
  power: {
    "prismatic-lfp-cell": {
      id: "prismatic-lfp-cell",
      title: "Prismatic LFP Cell",
      category: "Power Battery",
      description:
        "Lithium Iron Phosphate cells offering exceptional safety and long cycle life for power applications.",
      images: ["/prismalfp.jpg"],
      features: [
        { icon: Battery, title: "Enhanced Safety", desc: "Stable chemistry" },
        { icon: Clock, title: "Long Cycle Life", desc: "3000+ cycles" },
        {
          icon: Thermometer,
          title: "Thermal Stability",
          desc: "Wide range operation",
        },
        { icon: Zap, title: "High Power", desc: "Excellent discharge rates" },
        {
          icon: TrendingDown,
          title: "Eco-Friendly",
          desc: "Non-toxic materials",
        },
        { icon: Settings, title: "Maintenance Free", desc: "Sealed design" },
      ],
      applications: [
        { 
          name: "Solar Storage",
          image: "/Products/applications/solarstorage.png"
        },
        { 
          name: "Electric Vehicles",
          image: "/Products/applications/evvehicle.png"
        },
        { 
          name: "Telecom",
          image: "/Products/applications/telecom.png"
        },
        { 
          name: "Grid Storage",
          image: "/Products/applications/gridstorage.png"
        },
      ],
      specs: {
        capacity: "50-300Ah",
        voltage: "3.2V",
        temperature: "-30°C to +60°C",
        cycleLife: "3000+ cycles",
      },
    },
    "prismatic-lithium-cells": {
      id: "prismatic-lithium-cells",
      title: "Prismatic Lithium Cells",
      category: "Power Battery",
      description:
        "High-power cells for demanding industrial and automotive applications.",
      images: [
        "/grapheneprisma (2).png",
        // "/Products/graphene-power-2.jpg",
      ],
      features: [
        { icon: Zap, title: "Ultra-Fast Charging", desc: "0-80% in 20min" },
        {
          icon: Battery,
          title: "High Power Density",
          desc: "Exceptional output",
        },
        {
          icon: Thermometer,
          title: "Wide Temperature",
          desc: "-40°C to +75°C",
        },
        { icon: Clock, title: "Extended Life", desc: "2000+ cycles" },
        {
          icon: Settings,
          title: "Enhanced Conductivity",
          desc: "Superior conductivity",
        },
        { icon: TrendingDown, title: "Low Resistance", desc: "Minimal loss" },
      ],
      applications: [
        { 
          name: "Performance EVs",
          image: "/Products/applications/performanceev.png"
        },
        { 
          name: "Aerospace",
          image: "/Products/applications/aerospace.png"
        },
        { 
          name: "Racing",
          image: "/Products/applications/racing.png"
        },
        { 
          name: "Power Tools",
          image: "/Products/applications/powertools.png"
        },
      ],
      specs: {
        capacity: "20-150Ah",
        voltage: "3.7V",
        temperature: "-40°C to +75°C",
        cycleLife: "2000+ cycles",
      },
    },
    module: {
      id: "module",
      title: "Battery Module",
      category: "Power Battery",
      description:
        "Complete battery modules with integrated management for scalable power solutions.",
      images: ["/batterymodulke.avif"],
      features: [
        {
          icon: Settings,
          title: "Integrated BMS",
          desc: "Built-in management",
        },
        { icon: Battery, title: "Scalable Design", desc: "Flexible capacity" },
        { icon: Zap, title: "Robust Construction", desc: "Industrial grade" },
        {
          icon: Thermometer,
          title: "Advanced Cooling",
          desc: "Efficient thermal",
        },
        { icon: Clock, title: "Plug-and-Play", desc: "Easy installation" },
        {
          icon: TrendingDown,
          title: "Safety Certified",
          desc: "International standards",
        },
      ],
      applications: [
        { 
          name: "Energy Storage",
          image: "/Products/applications/powerstorage.png"
        },
        { 
          name: "E-Mobility",
          image: "/Products/applications/emobility.png"
        },
        { 
          name: "Backup Power",
          image: "/Products/applications/backuppower.png"
        },
        { 
          name: "Marine",
          image: "/Products/applications/marine.png"
        },
      ],
      specs: {
        capacity: "1-20kWh",
        voltage: "24-800V",
        temperature: "-20°C to +55°C",
        cycleLife: "4000+ cycles",
      },
    },
  },
};

export const firstProducts = {
  consumer: "lithium-ion-battery",
  power: "prismatic-lfp-cell",
};

export const allProducts = {
  ...productsData.consumer,
  ...productsData.power,
};